import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { AppDispatch } from '@/store';
import { auth } from '@/services/firebase';
import { signInWithGoogle, signOut } from '@/store/auth/actions';
import { selectAuthState } from '@/selectors/auth';
import { UseLogin } from '../Login.types';

export const useLogin: UseLogin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { signInError, signOutError } = useSelector(selectAuthState);

  const handleSignIn = (): void => {
    dispatch(signInWithGoogle());
  };

  /* A sign-in the backend refused (no or unknown role) leaves a live Firebase
     session behind; end it so the next attempt starts clean. `signOut` must be
     called — dispatching the bare action creator never ran it. */
  useEffect(() => {
    if (auth.currentUser && signInError) {
      dispatch(signOut());
    }
  }, [dispatch, signInError]);

  return {
    handleSignIn,
    signInError,
    signOutError
  };
};
